import { Search, BarChart3, Bookmark, CalendarClock, FileDown, MessageCircle, Settings, SunMoon } from "lucide-react";

const Btn = ({ label, onClick, Icon, testid }) => (
  <button onClick={onClick} aria-label={label} title={label} data-testid={testid}
    className="h-11 w-11 rounded-full bg-[#F3F7F2] text-[#24331F] flex items-center justify-center hover:bg-[#5FA8D9] transition-colors shrink-0">
    <Icon className="h-[18px] w-[18px]" />
  </button>
);

// Barra negra de acciones rápidas: cada botón llama a una acción que ya existe en la pantalla.
export const MenuFlotante = ({ acciones }) => {
  const items = [
    acciones.buscar && { label: "Buscar", Icon: Search, onClick: acciones.buscar, testid: "fab-buscar" },
    acciones.analisis && { label: "Nuevo análisis", Icon: BarChart3, onClick: acciones.analisis, testid: "fab-analisis" },
    acciones.guardados && { label: "Guardados", Icon: Bookmark, onClick: acciones.guardados, testid: "fab-guardados" },
    acciones.vencimientos && { label: "Vencimientos", Icon: CalendarClock, onClick: acciones.vencimientos, testid: "fab-vencimientos" },
    acciones.exportar && { label: "Exportar", Icon: FileDown, onClick: acciones.exportar, testid: "fab-exportar" },
    acciones.whatsapp && { label: "Enviar por WhatsApp", Icon: MessageCircle, onClick: acciones.whatsapp, testid: "fab-whatsapp" },
  ].filter(Boolean);
  const abajo = [
    acciones.ajustes && { label: "Ajustes", Icon: Settings, onClick: acciones.ajustes, testid: "fab-ajustes" },
    acciones.tema && { label: "Tema claro / oscuro", Icon: SunMoon, onClick: acciones.tema, testid: "fab-tema" },
  ].filter(Boolean);
  return (
    <aside data-testid="menu-flotante" aria-label="Acciones rápidas"
      className="tm-tierra fixed z-30 flex items-center gap-2 p-2 rounded-[32px] lg:flex-col lg:left-4 lg:top-1/2 lg:-translate-y-1/2 lg:w-16 lg:py-3 bottom-[max(12px,env(safe-area-inset-bottom))] left-1/2 -translate-x-1/2 lg:translate-x-0 lg:bottom-auto max-w-[calc(100vw-24px)] overflow-x-auto scrollbar-none">
      {items.map((b) => <Btn key={b.testid} {...b} />)}
      {abajo.length > 0 && <div className="lg:w-8 lg:h-px w-px h-8 bg-white/25 shrink-0 mx-1 lg:mx-0 lg:my-1" />}
      {abajo.map((b) => <Btn key={b.testid} {...b} />)}
    </aside>
  );
};
